const MAX_LOGO_SIZE_BYTES = 1024 * 1024;

const readBlobAsDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });

/**
 * Keeps an optional logo available in the cached tenant bootstrap. Failures are
 * intentionally ignored because a logo must never prevent local operation.
 */
export const createCompanyLogoCache = ({
  fetchLogo = (...args) => fetch(...args),
  readAsDataUrl = readBlobAsDataUrl,
} = {}) => ({
  async cache(tenantBootstrap) {
    if (
      !tenantBootstrap?.companyLogoUrl ||
      tenantBootstrap.companyLogoDataUrl ||
      typeof fetchLogo !== "function"
    ) {
      return tenantBootstrap;
    }

    try {
      const response = await fetchLogo(tenantBootstrap.companyLogoUrl, {
        cache: "no-store",
      });
      if (!response?.ok) return tenantBootstrap;

      const logoBlob = await response.blob();
      if (!logoBlob.size || logoBlob.size > MAX_LOGO_SIZE_BYTES) {
        return tenantBootstrap;
      }

      const companyLogoDataUrl = await readAsDataUrl(logoBlob);
      if (typeof companyLogoDataUrl !== "string") return tenantBootstrap;

      return {
        ...tenantBootstrap,
        companyLogoDataUrl,
        companyLogoCachedAt: new Date().toISOString(),
      };
    } catch {
      return tenantBootstrap;
    }
  },
});
